define 'controller/RecommendationOnClickController', ['jquery'], ($) ->
  class RecommendationOnClickController

    constructor: (@$el) ->
      @_init()

    _init: ->
      # index page: .product__carousel
      # product detail page taste (including addtobasket popup): .product__carousel
      # basket page: .recommendations__item
      $('.product__carousel, .product__similar-items__carousel, .recommendations__item').on 'click', '.slick-slide', this._clickFunction

    _clickFunction: (event) =>
      article = $(event.target).closest('[data-articlenumber]')
      base64String = @$el.data('datalayerevent')
      articleNumber = '' + article.data('articlenumber')
      positionInView = parseInt(article.data('index')) + 1
      jsonArray = []

      try
        jsonArray = JSON.parse(decodeURIComponent(escape(atob(base64String))))
      catch e
        try
          jsonArray = JSON.parse(atob(base64String))
        catch e

      for jsonString in jsonArray
        if (jsonString.eventInfo.productList[0].art_nr == articleNumber)
          jsonString.eventInfo.productList[0].position = positionInView
          dataLayer.push(jsonString)
